import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ICommentModel } from '@fi-app/shared/models';
import { FiCommentsListHelperService } from '../../services/fi-comments-list-helper.service';
import { FiProfileSizes } from '@fi-app/shared/profile-icon/profile-icon.component';
import { FiCommentsListStateService } from '../../services/fi-comments-list-state.service';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-comment-header',
    templateUrl: './fi-comment-header.component.html',
    styleUrls: ['./fi-comment-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-comment-header' },
    standalone: false,
})
export class FiCommentHeaderComponent {
    @Input({ required: true }) comment: ICommentModel;
    @Input({ required: true }) objectId: number;
    @Input({ required: true }) objectType: ObjectTypes;
    @Input({ required: true }) instanceId: string;
    @Input() isDisabled: boolean = false;
    @Input() hasDeleteAccessOfOwnerItem: boolean;
    @Input() isEditorShown: boolean = false;
    @Output() onEditButtonClick = new EventEmitter<void>();

    protected readonly ProfileSizes = FiProfileSizes;

    constructor(
        private commentsListHelperService: FiCommentsListHelperService,
        private commentsListStateService: FiCommentsListStateService,
        private sharedActionsBaseService: SharedActionsBaseService,
    ) {}

    protected isCommentChanged(): boolean {
        return this.commentsListHelperService.isCommentChanged(this.comment);
    }

    protected isMenuAvailable(): boolean {
        return !this.isDisabled && (this.isEditActionEnabled() || this.isRemoveActionEnabled());
    }

    protected isEditActionEnabled(): boolean {
        return this.commentsListHelperService.isEditActionEnabled(this.comment.CreatedByUserId);
    }

    protected isRemoveActionEnabled(): boolean {
        return this.commentsListHelperService.isRemoveActionEnabled(
            this.comment.CreatedByUserId,
            this.hasDeleteAccessOfOwnerItem,
        );
    }

    protected toggleEdit($event: MouseEvent): void {
        $event.preventDefault();
        this.onEditButtonClick.emit();
    }

    protected openUserViewPopup($event: MouseEvent) {
        $event.preventDefault();
        this.sharedActionsBaseService.openUserViewPopup(this.comment.CreatedByUserId);
    }

    protected deleteComment(): void {
        this.commentsListStateService.emitDeleteComment({
            ObjectId: this.objectId,
            ObjectType: this.objectType,
            Comment: this.comment,
            InstanceId: this.instanceId,
        });
    }
}
